/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Oauth_Success_TitleInputs */



/**
* | output |
* | --- |
* | "OAuth Connection Successful!" |
*
* @param {Spaces_Oauth_Success_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_oauth_success_title = /** @type {((inputs?: Spaces_Oauth_Success_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Oauth_Success_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("OAuth-Verbindung erfolgreich!")
	return /** @type {LocalizedString} */ ("OAuth Connection Successful!")
});